import React, { useState } from "react";

import { Fade } from "react-reveal";
import CloseImage from "../../assets/images/close.svg";
import MenuImage from "../../assets/images/menu.svg";

import {
  Container,
  NavBtn,
  Nav,
  Logo,
  NavRow,
  NavColumn,
  MenuIcon,
} from "./header_elements";
import { introSection } from "../../data";

const Header = () => {
  const [menu, setMenu] = useState(false);

  const dis = (
    <>
      <NavBtn href="#skills">Skils</NavBtn>
      <NavBtn href="#proficiency">Proficiency</NavBtn>
      <NavBtn href="#experience">Work Experience</NavBtn>
      <NavBtn href="#projects">Projects</NavBtn>
      <NavBtn href="#reviews">Reviews</NavBtn>
      <NavBtn href="#contact">Contact me</NavBtn>
      <NavBtn
        href={
          "mailto:" + introSection.email + "?subject=Hey, I want to hire you!"
        }
      >
        Hire me
      </NavBtn>
    </>
  );

  return (
    <Container>
      <Nav>
        <Fade top duration={1000}>
          <Logo>
            <span>Safwan Mamji</span>
          </Logo>
        </Fade>

        <NavRow>
          <Fade top duration={1000}>
            {dis}
          </Fade>
        </NavRow>

        <MenuIcon onClick={() => setMenu(!menu)}>
          {menu ? (
            <img src={MenuImage} alt="Menu"></img>
          ) : (
            <img src={CloseImage} alt="Close"></img>
          )}
        </MenuIcon>
      </Nav>
      {menu ? (
        <NavColumn>
          {/* <Fade bottom duration={1000}> */}
          {dis}
          {/* </Fade> */}
        </NavColumn>
      ) : (
        <div></div>
      )}
    </Container>
  );
};

export default Header;
